import { SoundType } from '@slot-nx/core'
import { ThreeComboOlympusSoundType } from '../enum/ThreeComboOlympusSoundType'

export const GameSoundType = {
  ...SoundType,
  ...ThreeComboOlympusSoundType,
}
